import { secretFieldToSubmit } from '../../utils/secretFields';

export function buildAccountPayload(form, { tokenEditing } = {}) {
  const payload = {
    label: form.label.trim(),
    sort_order: Number(form.sort_order) || 0,
    is_active: form.is_active,
    account_ids: form.account_ids || [],
  };

  const igUserId = form.ig_user_id.trim();
  const isPending = !igUserId || igUserId.toLowerCase() === 'pending';
  if (!isPending) {
    payload.ig_user_id = igUserId;
  } else if (!form.id) {
    payload.ig_user_id = null;
  } else {
    // Keep sending pending so the backend can resolve it from the token
    payload.ig_user_id = igUserId || 'pending';
  }

  const token = secretFieldToSubmit(form.token, { editing: tokenEditing });
  if (token) {
    payload.token = token;
  }

  return payload;
}

export default buildAccountPayload;
